import { useState, useEffect } from 'react';
import DownloadButton from '../../components/DownloadButton/DownloadButton';
import { getJsonUrl } from '../../utils/fileDownloader';
import './HistoricalComparisons.css';

const HistoricalComparisons = () => {
  const [historicalFiles, setHistoricalFiles] = useState([]);
  const [officialsFiles, setOfficialsFiles] = useState([]);

  useEffect(() => {
    fetch(getJsonUrl())
      .then(res => res.json())
      .then(data => {
        setHistoricalFiles(data.historicalComparisons || []);
        setOfficialsFiles(data.listOfElectedOfficials || []);
      })
      .catch(err => console.error('Error fetching data:', err));
  }, []);

  return (
    <div className="page-container">
      <h2 className="vr-header">Historical Results Comparisons & List of Elected Officials</h2>

      <section className="section">
        <h3 className="section-title">Historical Election Results Comparisons</h3>
        <div className="summary-text">
          <p>Access the comparisons for voter turnout in general elections, primary elections,
            gubernatorial elections, presidential elections, statewide issue history, and
            proposed constitutional amendments, initiated legislation, and laws challenged
            by referendum.</p>
        </div>
        <div className="download-button-grid">
          {historicalFiles.map(file => (
            <DownloadButton
              key={file.displayName}
              blobPath={file.blobPath}
              displayName={file.displayName}
            >
              {file.displayName}
            </DownloadButton>
          ))}
        </div>
      </section>

      <section className="section">
        <h3 className="section-title">List of Elected Officials</h3>
        <div className="summary-text">
          <p>Access lists of elected officials and comparisons of the election results for specific offices. 
            Comparisons for elected Governors, Lieutenant Governors, Secretaries of State, Auditors, Treasurers, 
            Attorneys, Justices of the Supreme Court, Adjuncts General, Presidents of the United States of 
            America, and Representatives to Congress are included.</p>
        </div>
        <div className="download-button-grid">
          {officialsFiles.map(file => (
            <DownloadButton
              key={file.displayName}
              blobPath={file.blobPath}
              displayName={file.displayName}
            >
              {file.displayName}
            </DownloadButton>
          ))}
        </div>
      </section>
    </div>
  );
};

export default HistoricalComparisons;